export default "__VITE_ASSET__CyeMIKzE__"